angular.module('acme.view.application.membership.categories.create.description', [
  'ui.router',
  'ui.bootstrap',
  'acme.view.application.membership.categories.create.description.controllers'
])

.config(function config($stateProvider) {

  var membershipCategoriesCreateDescription = {
    name: 'application.membership.categories.create.description',
    url: '/description',
    views: {
      "subview-main": {
        controller: 'MembershipCategoriesCreateDescriptionController',
        templateUrl: 'views/application/views/membership/categories/create/description/description.tpl.html'
      }
    },
    data: {
      pageTitle: 'Create Membership Category'
    }
  },
  membershipCategoriesEditDescription = {
    name: 'application.membership.categories.edit.description',
    url: '/description',
    views: {
      "subview-main": {
        controller: 'MembershipCategoriesCreateDescriptionController',
        templateUrl: 'views/application/views/membership/categories/create/description/description.tpl.html'
      }
    },
    data: {
      pageTitle: 'Edit Membership Category'
    }
  };

  $stateProvider
    .state(membershipCategoriesCreateDescription)
    .state(membershipCategoriesEditDescription);
});
